import React from 'react'
import { Switch as AntSwitch } from 'antd'
import { SwitchProps as AntSwitchProps } from 'antd/lib/switch'

import './Switch.module.css'

type Props = AntSwitchProps

export const Switch = React.forwardRef<HTMLElement, Props>(
  (
    { className, onChange, size, checked, defaultChecked, loading, disabled },
    ref
  ) => {
    const controlledProps = {
      ...(checked !== undefined && { checked })
    }

    return (
      <AntSwitch
        ref={ref}
        className={className}
        onChange={onChange}
        size={size}
        defaultChecked={defaultChecked}
        loading={loading}
        disabled={disabled}
        {...controlledProps}
      />
    )
  }
)
